import React from "react";
import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { Hero } from "../components/Hero";

const HERO_DESKTOP = "/images/hero/HeroImageContatti-Desktop.webp";
const HERO_MOBILE = "/images/hero/HeroImageContatti-Mobile.webp";

const MAPS_EMBED_SRC =
  "https://www.google.com/maps?q=Via+Costanza+12%2F14,+Livorno&hl=it&z=16&output=embed";

export default function Contatti() {
  return (
    <>
      <Hero
        testId="contatti-hero"
        desktopImage={HERO_DESKTOP}
        mobileImage={HERO_MOBILE}
        alt="Pizzeria Salviano - Contatti a Livorno"
        eyebrow="Ti aspettiamo"
        title="Contatti"
        subtitle="Pizzeria Salviano — Via Costanza 12/14, Livorno"
        actions={
          <>
            <a href="tel:+390586326286" className="ps-btn ps-btn-primary" data-testid="contatti-hero-call">
              <Phone size={18} /> Chiama ora
            </a>
            <a href="https://wa.me/393703640199" target="_blank" rel="noopener noreferrer" className="ps-btn ps-btn-whatsapp" data-testid="contatti-hero-whatsapp">
              <MessageCircle size={18} /> WhatsApp
            </a>
          </>
        }
      />

      <section className="py-16 sm:py-20" style={{ background: "var(--ps-cream)" }}>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div data-testid="contatti-info">
            <span className="ornament font-display text-sm sm:text-base uppercase tracking-[0.3em]">Informazioni</span>
            <h2 className="section-title mt-5 text-3xl sm:text-4xl lg:text-5xl">Vieni a trovarci</h2>
            <p className="mt-5 text-[var(--ps-ink-soft)] leading-relaxed text-lg sm:text-xl">
              Hai bisogno di informazioni o vuoi <strong>prenotare</strong>? Contatta la <strong>Pizzeria Salviano</strong> a
              Livorno in <strong>Via Costanza 12/14</strong>.
            </p>

            <div className="mt-8 space-y-4">
              <a
                href="https://www.google.com/maps?q=Via+Costanza+12%2F14,+Livorno"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-4 p-5 rounded-lg bg-white shadow-sm border border-[rgba(31,23,18,0.08)] hover:shadow-md transition-shadow"
                data-testid="contact-address"
              >
                <span className="w-14 h-14 shrink-0 rounded-full flex items-center justify-center bg-[rgba(139,30,30,0.08)] text-[var(--ps-red)]">
                  <MapPin size={24} />
                </span>
                <div>
                  <div className="text-xs uppercase tracking-[0.18em] text-[var(--ps-ink-soft)] font-semibold">Indirizzo</div>
                  <div className="font-display text-xl text-[var(--ps-ink)] mt-1">Via Costanza 12/14, Livorno</div>
                  <div className="text-sm text-[var(--ps-red)] mt-1 font-medium">Apri in Google Maps →</div>
                </div>
              </a>

              <a
                href="tel:+390586326286"
                className="flex items-start gap-4 p-5 rounded-lg bg-white shadow-sm border border-[rgba(31,23,18,0.08)] hover:shadow-md transition-shadow"
                data-testid="contact-phone"
              >
                <span className="w-14 h-14 shrink-0 rounded-full flex items-center justify-center bg-[rgba(139,30,30,0.08)] text-[var(--ps-red)]">
                  <Phone size={24} />
                </span>
                <div>
                  <div className="text-xs uppercase tracking-[0.18em] text-[var(--ps-ink-soft)] font-semibold">Telefono fisso</div>
                  <div className="font-display text-xl text-[var(--ps-ink)] mt-1">0586 326286</div>
                </div>
              </a>

              <a
                href="https://wa.me/393703640199"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-4 p-5 rounded-lg bg-white shadow-sm border border-[rgba(31,23,18,0.08)] hover:shadow-md transition-shadow"
                data-testid="contact-whatsapp"
              >
                <span className="w-14 h-14 shrink-0 rounded-full flex items-center justify-center bg-[rgba(34,197,94,0.12)] text-[#22c55e]">
                  <MessageCircle size={24} />
                </span>
                <div>
                  <div className="text-xs uppercase tracking-[0.18em] text-[var(--ps-ink-soft)] font-semibold">Cellulare / WhatsApp</div>
                  <div className="font-display text-xl text-[var(--ps-ink)] mt-1">370 3640199</div>
                </div>
              </a>

              <div className="flex items-start gap-4 p-5 rounded-lg bg-white shadow-sm border border-[rgba(31,23,18,0.08)]" data-testid="contact-hours">
                <span className="w-14 h-14 shrink-0 rounded-full flex items-center justify-center bg-[rgba(139,30,30,0.08)] text-[var(--ps-red)]">
                  <Clock size={24} />
                </span>
                <div className="flex-1">
                  <div className="text-xs uppercase tracking-[0.18em] text-[var(--ps-ink-soft)] font-semibold">Orari di apertura</div>
                  <ul className="mt-2 text-base sm:text-lg space-y-1">
                    <li className="flex justify-between gap-6"><span className="font-medium">Lunedì</span><span className="text-[var(--ps-red)] font-semibold">Chiuso</span></li>
                    <li className="flex justify-between gap-6"><span className="font-medium">Martedì</span><span>18:00 · 21:30</span></li>
                    <li className="flex justify-between gap-6"><span className="font-medium">Mercoledì</span><span>18:00 · 21:30</span></li>
                    <li className="flex justify-between gap-6"><span className="font-medium">Giovedì</span><span>18:00 · 21:30</span></li>
                    <li className="flex justify-between gap-6"><span className="font-medium">Venerdì</span><span>18:00 · 21:30</span></li>
                    <li className="flex justify-between gap-6"><span className="font-medium">Sabato</span><span>18:00 · 21:30</span></li>
                    <li className="flex justify-between gap-6"><span className="font-medium">Domenica</span><span>18:00 · 21:30</span></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a href="tel:+390586326286" className="ps-btn ps-btn-gold" data-testid="btn-call-again">
                <Phone size={16} /> Chiama ora
              </a>
              <a href="https://wa.me/393703640199" target="_blank" rel="noopener noreferrer" className="ps-btn ps-btn-whatsapp" data-testid="btn-whatsapp-again">
                <MessageCircle size={16} /> Scrivici su WhatsApp
              </a>
            </div>
          </div>

          <div
            className="rounded-lg overflow-hidden shadow-lg border border-[rgba(31,23,18,0.08)] w-full self-start"
            data-testid="contact-map"
            style={{ aspectRatio: "1 / 1" }}
          >
            <iframe
              title="Mappa Pizzeria Salviano — Via Costanza 12/14, Livorno"
              src={MAPS_EMBED_SRC}
              width="100%"
              height="100%"
              style={{ border: 0, display: "block" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </section>
    </>
  );
}
